import {
  CanDownloadContext,
  CanGenerateByOneflowContext,
  CanPreviewContext,
  CanSendToOneflowContext,
  GetOneflowTemplateIdContext,
  IConsultantContractStrategy
} from "../consultant-contract-strategy";

export class BcFrameworkContractStrategy implements IConsultantContractStrategy {
  public readonly name = "BcFrameworkContractStrategy";

  canPublishToOneflowDirectly(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  canPublishToOneflowViaTicket(ctx: CanSendToOneflowContext): boolean {
    return true;
  }

  getOneflowTemplateId(ctx: GetOneflowTemplateIdContext) {
    if (ctx.env === "dev" || ctx.env === "staging") {
      return {
        workspaceId: "419741",
        templateId: "5857905"
      };
    }

    if (ctx.env === "production") {
      return {
        workspaceId: "421117",
        templateId: "5777184"
      };
    }

    throw new Error("unknown env");
  }

  canDuplicate(): boolean {
    return true;
  }

  canEdit(): boolean {
    return true;
  }

  canPreview(ctx: CanPreviewContext): boolean {
    return true;
  }

  canDownload(ctx: CanDownloadContext): boolean {
    return !!ctx.fileId
  }

  getOneflowGeneratorType(ctx: CanGenerateByOneflowContext) {
    return null;
  }

  defaultSalaryChoice(): null {
    return null;
  }
}
